/*eslint-disable*/
import { Spin } from 'antd';
import propTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { matchPath, Redirect, Route, useLocation } from 'react-router-dom';

import Cookies from 'js-cookie';
import actions from '../../redux/authentication/actions';
import { fetchUserDetails } from '../../redux/users/userDetails/actionCreator';

const { logoutBegin, logoutSuccess } = actions;

function ProtectedRoute({ component, path }) {
  const dispatch = useDispatch();
  const location = useLocation();

  const { isLoggedIn, user, loggedInUserRole, isLoading } = useSelector((state) => {
    return {
      isLoggedIn: state.auth.login,
      user: state.userDetails.user,
      loggedInUserRole: state.auth.login.user?.role,
      isLoading: state.userDetails.loading,
    };
  });

  const [redirectTimeExpired, setRedirectTimeExpired] = useState(false);

  useEffect(() => {
    if (isLoggedIn?.user?.id) {
      dispatch(fetchUserDetails(isLoggedIn.user.id));
    }
  }, [dispatch, isLoggedIn?.user?.id]);

  const isAdmin = loggedInUserRole === 'Admin' || loggedInUserRole === 'Assistant';

  const isUserEmpty = !user || (typeof user === 'object' && Object.keys(user).length === 0);
  
  const isDataMissing = isUserEmpty || (!isAdmin && !user.subscription);

  const shouldWait = isLoading || isDataMissing;

  useEffect(() => {
    let timer;
    if (shouldWait) {
      timer = setTimeout(() => {
        setRedirectTimeExpired(true);
      }, 5000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [shouldWait]);

  if (shouldWait) {
    if (redirectTimeExpired && !isLoading) {
      dispatch(logoutBegin());
      Cookies.remove('logedIn');
      Cookies.remove('token');
      Cookies.remove('userId');
      dispatch(logoutSuccess(null));
      return <Redirect to="/" />;
    }

    return (
      <div className="spin">
        <Spin />
      </div>
    );
  }

  const isSubscriptionActive = user?.subscription?.isActive || user?.subscription?.isTrial;
  const hasSubscriptionHistory = user?.subscriptionHistory?.length > 0;

  const isCheckoutRoute = matchPath(location.pathname, {
    path: '/admin/checkout',
    exact: true,
  });

  const isBillingPackagesRoute = matchPath(location.pathname, {
    path: '/admin/billing/packages',
    exact: true,
  });

  if (isAdmin) {
    return <Route component={component} path={path} />;
  }

  if (isSubscriptionActive || hasSubscriptionHistory) {
    return <Route component={component} path={path} />;
  }

  if (isCheckoutRoute || isBillingPackagesRoute) {
    return <Route component={component} path={path} />;
  }

  return <Redirect to="/admin/checkout" />;
}

ProtectedRoute.propTypes = {
  component: propTypes.elementType.isRequired,
  path: propTypes.string.isRequired,
};

export default ProtectedRoute;